import { observer } from 'mobx-react'

import BoxList from 'modules/core/components/BoxList'
import SortableBoxList from 'modules/core/components/SortableBoxList'
import i18n from 'modules/core/lib/i18n'

import { useQuestionsTemplate } from 'modules/app_store/pages/QuestionsTemplates/MainContent/QuestionsContent/questionsTemplateContext'
import type TemplateQuestion from 'modules/surveys/store/models/TemplateQuestion'

import Item from '../Item'
import type {
  CreateTemplateQuestion,
  DeleteTemplateQuestion,
  ReorderTemplateQuestion,
  UpdateTemplateQuestion,
} from '../types'

interface Props {
  templateQuestions: TemplateQuestion[]
  updateTemplateQuestion: (data: UpdateTemplateQuestion) => Promise<unknown>
  createTemplateQuestion: (
    data: CreateTemplateQuestion,
    questionsTemplateCategoryId?: number
  ) => Promise<unknown>
  reorderTemplateQuestion: (data: ReorderTemplateQuestion) => Promise<unknown>
  deleteTemplateQuestion: (data: DeleteTemplateQuestion) => Promise<unknown>
  isCore: boolean
}

const TemplateQuestionsWithoutCategory = ({
  templateQuestions,
  updateTemplateQuestion,
  createTemplateQuestion,
  reorderTemplateQuestion,
  deleteTemplateQuestion,
  isCore,
}: Props) => {
  const { isDefault } = useQuestionsTemplate()
  const items = templateQuestions.sort((a, b) => (a.get('position') > b.get('position') ? 1 : -1))

  const onSortEnd = (itemsToSort: TemplateQuestion[]) => {
    itemsToSort.map((item, index) => {
      reorderTemplateQuestion({
        id: item.attributes.id,
        newPosition: index,
      })
    })
  }

  const RenderedItem = ({ item }: { item: TemplateQuestion }) => (
    <Item
      templateQuestion={item}
      updateTemplateQuestion={updateTemplateQuestion}
      createTemplateQuestion={createTemplateQuestion}
      deleteTemplateQuestion={deleteTemplateQuestion}
      isCore={isCore}
    />
  )

  if (isDefault) {
    return (
      <BoxList>
        {items.map((item) => (
          <RenderedItem key={item.get('id')} item={item} />
        ))}
      </BoxList>
    )
  }

  return (
    <SortableBoxList
      items={items}
      onSortEnd={onSortEnd}
      emptyMessage={i18n.t('surveys.form.question_configs.no_question_configs')}
      itemAsKey={(item) => item.attributes.id.toString()}
      renderItem={(item) => <RenderedItem item={item} />}
    />
  )
}

export default observer(TemplateQuestionsWithoutCategory)
